import { IoClose } from "react-icons/io5";
import { FilterChipProps } from "./types";

const FilterChip = ({
  title,
  label,
  onClose,
  className,
  hideCloseButton = false,
}: FilterChipProps) => {
  return (
    <div
      className={`flex items-center space-x-2 rounded-lg bg-blue-500 py-1 pl-3 pr-1 text-sm text-zinc-50 ${className || ""}`}
    >
      {title && <p className="font-medium">{title}:</p>}
      <p className="font-normal">{label}</p>
      {!hideCloseButton && (
        <button
          onClick={onClose}
          className="ml-auto h-8 w-8 rounded-full p-1 text-zinc-50 hover:bg-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
          aria-label="Remove filter"
        >
          <IoClose size={24} />
        </button>
      )}
    </div>
  );
};

export default FilterChip;
